import { SwapServiceAbstract } from '@cronos-app/swap-sdk';
import { ADDRESS_THIS_BY_CHAIN, ROUTER_SC_BY_CHAIN } from '../configs/sc';
import { ERC20__factory, H2Router__factory } from '../contracts';
import { getContract } from '../utils/getContract';
import { toWrappedTokenFactory } from '../utils/toWrappedTokenFactory';
const routerInterface = H2Router__factory.createInterface();
export class SwapService extends SwapServiceAbstract {
    constructor(chainId) {
        const spender = ROUTER_SC_BY_CHAIN[chainId];
        if (!spender)
            throw new Error('No router address found for chain');
        const addressThis = ADDRESS_THIS_BY_CHAIN[chainId];
        // NOTE: This is the address of the GasRefund contract on the Cronos ZKEVM testnet and mainnet
        const gasRefundContract = '0x0000000000000000000000000000000000008001';
        super(spender, addressThis, gasRefundContract);
        this.chainId = chainId;
        this.toWrappedToken = toWrappedTokenFactory(this.chainId);
        this.isNativeToken = (token) => {
            return (token.address.toLowerCase() !==
                this.toWrappedToken(token).address.toLowerCase());
        };
        this.isPerformAggregatedSlippageCheck = (trade) => {
            // flag for whether we want to perform an aggregated slippage check
            //   1. when there are >2 exact input trades. this is only a heuristic,
            //      as it's still more gas-expensive even in this case, but has benefits
            //      in that the reversion probability is lower
            // TradeType.EXACT_INPUT
            return trade.routes.length > 2;
        };
        this.isRouterMustCustody = (trade, options) => {
            // flag for whether funds should be send first to the router
            //   1. when receiving ETH (which much be unwrapped from WETH)
            //   2. when a fee on the output is being taken
            //   3. when performing swap and add
            //   4. when performing an aggregated slippage check
            return (this.isNativeToken(options.from) ||
                !!options.fee ||
                this.isPerformAggregatedSlippageCheck(trade));
        };
        this.encodeFunctionData_sweepToken = (amount, recipient) => {
            return routerInterface.encodeFunctionData('sweepToken', [
                amount.address,
                amount.amount,
                recipient,
            ]);
        };
        this.encodeFunctionData_v3_exactInput = (amountIn, amountOutMinimum, path, recipient) => {
            return routerInterface.encodeFunctionData('exactInput', [
                {
                    path,
                    amountIn,
                    amountOutMinimum,
                    recipient,
                },
            ]);
        };
        this.encodeFunctionData_v2_swapExactTokensForTokens = (amountIn, amountOutMinimum, path, account) => {
            return routerInterface.encodeFunctionData('swapExactTokensForTokens', [
                amountIn,
                amountOutMinimum,
                path,
                account,
            ]);
        };
        this.multicall = (signer, calldatas, value) => {
            return getContract(this.chainId, this.spender, H2Router__factory.abi, signer)['multicall(bytes[])'](calldatas, {
                value,
            });
        };
        this.estimateGasOfMulticall = (signer, calldatas, value) => {
            return getContract(this.chainId, this.spender, H2Router__factory.abi, signer)['multicall(bytes[])'].estimateGas(calldatas, {
                value,
            });
        };
        this.allowance = (account, spender, amount) => {
            return getContract(this.chainId, amount.address, ERC20__factory.abi).allowance(account, spender);
        };
        this._approve = (spender, amount, signer) => {
            return getContract(this.chainId, amount.address, ERC20__factory.abi, signer).approve(spender, amount.amount);
        };
    }
}
